import type { Ref } from 'react';

import type { EuVatCountryCode } from '~/api/common/types';

import { Input } from '~/components/Form';

/** The country code is picked separately, so it's shown as a prefix and stripped from what's typed. */
export const VatNumberInput = ({
  countryCode,
  onBlur,
  onChange,
  ref,
  value,
}: {
  countryCode: EuVatCountryCode;
  onBlur?: () => void;
  onChange: (value: string) => void;
  ref?: Ref<HTMLInputElement>;
  value: string;
}) => {
  return (
    <Input
      autoComplete="off"
      autoFocus
      onBlur={onBlur}
      onValueChange={onChange}
      prefix={countryCode}
      ref={ref}
      transformValue={(value) => (value.toUpperCase().startsWith(countryCode) ? value.slice(countryCode.length).trim() : value)}
      value={value}
    />
  );
};

export const ReadOnlyVatNumberInput = ({ countryCode, vatNumber }: { countryCode: EuVatCountryCode; vatNumber: string }) => {
  return <Input disabled prefix={countryCode} value={vatNumber} />;
};
